import { render, staticRenderFns } from "./luomai.vue?vue&type=template&id=7904944c&scoped=true&"
import script from "./luomai.vue?vue&type=script&lang=ts&"
export * from "./luomai.vue?vue&type=script&lang=ts&"
import style0 from "./luomai.vue?vue&type=style&index=0&id=7904944c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7904944c",
  null
  
)

export default component.exports